import { ref } from 'vue'

// Shared state: Map stores timer ID (when viewing) or null (when not viewing)
const pendingUpdates = ref(new Map())

export function useFcmPendingUpdates() {
  function add(id) {
    pendingUpdates.value.set(id, null)
  }

  function addWithTimer(id, timer) {
    pendingUpdates.value.set(id, timer)
  }

  function remove(id) {
    const timer = pendingUpdates.value.get(id)
    if (timer) clearTimeout(timer)
    pendingUpdates.value.delete(id)
  }

  function getIdsByPrefix(prefix) {
    return Array.from(pendingUpdates.value.keys())
      .filter((key) => key.startsWith(`${prefix}-`))
      .map((k) => k.slice(prefix.length + 1))
  }

  function has(id) {
    return pendingUpdates.value.has(id)
  }

  function get(id) {
    return pendingUpdates.value.get(id)
  }

  function clearAll() {
    pendingUpdates.value.forEach((timer) => {
      if (timer) clearTimeout(timer)
    })
    pendingUpdates.value.clear()
  }

  return {
    pendingUpdates, // Expose the ref itself for reactive access
    add,
    addWithTimer,
    remove,
    has,
    get,
    clearAll,
    getIdsByPrefix,
  }
}
